import { render } from "./RecensementForm.vue?vue&type=template&id=39309c9f&scoped=true&ts=true"
import script from "./RecensementForm.vue?vue&type=script&lang=ts"
export * from "./RecensementForm.vue?vue&type=script&lang=ts"

import "./RecensementForm.vue?vue&type=style&index=0&id=39309c9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39309c9f"]])

export default __exports__